"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("./AnimationObject");
var IndexedAnimationObject = (function (_super) {
    tslib_1.__extends(IndexedAnimationObject, _super);
    function IndexedAnimationObject(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    Object.defineProperty(IndexedAnimationObject.prototype, "index", {
        get: function () {
            return this._rawData.ix;
        },
        set: function (index) {
            this._rawData.ix = index;
        },
        enumerable: true,
        configurable: true
    });
    return IndexedAnimationObject;
}(AnimationObject_1.AnimationObject));
exports.IndexedAnimationObject = IndexedAnimationObject;
//# sourceMappingURL=IndexedAnimationObject.js.map